import script from "./UpgradeConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./UpgradeConfirm.vue?vue&type=script&setup=true&lang=js"

import "./UpgradeConfirm.vue?vue&type=style&index=0&id=10304b65&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10304b65"]])

export default __exports__